import createChangedRuneEntry from '../helpers/createChangedRuneEntry.js'
import isRuneChanged from '../helpers/isRuneChanged.js'
import isEmpty from '../helpers/isEmpty.js'
//--------------------
// track rune changes
//--------------------
export default function trackRuneChanges({
  change = null,
  rune,
  original_runes,
  changed_runes,
  character_id,
  delete: del = false,
} = {}) {
  console.log('===================================================')
  console.log('IN trackRuneChanges')
  console.log('rune name = ', rune.name)
  console.log('rune strength = ', rune.strength)
  // console.log('rune id = ', rune.id)
  console.log('rune = ', window.$deepCopy(rune))
  console.log('change = ', window.$deepCopy(change))
  // console.log('original_runes = ', window.$deepCopy(original_runes))
  // console.log('changed_runes = ', window.$deepCopy(changed_runes))
  console.log('----------------------------------')
  //---------------------
  // check args received
  //---------------------
  if (isEmpty(rune) || original_runes === undefined || changed_runes === undefined) {
    return []
  }
  /*
  -------------------------------------------------------------------------------------------------------------------------
   CHANGED ARRAY    ORIGINAL ARRAY     PARM ACTION         CHANGED ARRAY ACTION
  ---------------  ----------------   ------------         ---------------------
  A.    No               No               ADD              add (new character rune)          
  B.    No               Yes              UPDATE           add existing character rune update
  C.    Yes              Yes              UPDATE/REMOVE    further character rune update or reverting to original)
  D.    Yes              No               ADD              update same ADD entry (further updates having flagged addition)
  -------------------------------------------------------------------------------------------------------------------------
  */
  let rune_changed_parm = {}
  //---------------------------------------------------------------------------------
  // find rune in change array (using id if existing rune - or temp id for new rune)
  //---------------------------------------------------------------------------------
  const changed_idx = changed_runes.findIndex((c) => (rune.id != null ? c.id === rune.id : null))
  // console.log('XXXXX changed_idx = ', changed_idx)
  //--------------------------------------------------------------------
  // find rune in original array (wont be an original entry without id)
  //--------------------------------------------------------------------
  const original_idx = original_runes.findIndex((o) => o.id === rune.id)
  //=========================================================================================================================
  // A. where rune NOT in change array + NOT in original array (adding new character rune)
  //---------------------------------------------------------------------------------------
  if (changed_idx == -1 && original_idx == -1) {
    console.log('A. RUNE NOT IN CHANGED OR ORIGINAL ARRAY: ' + rune.name)
    //-------------------------------------------------------
    // static rune id passed from rune addition via RuneCard
    //-------------------------------------------------------
    rune_changed_parm = createChangedRuneEntry({
      name: rune.name,
      id: rune.id, // real or temp id used for tracking
      action: 'ADD',
      payload: {
        character: character_id ? character_id : null,
        rune: rune.rune ? rune.rune : null, // static rune id
        strength: rune.strength,
        pwr_storage: rune.pwr_storage,
        starter: rune.starter,
        integrated: rune.integrated,
        active: rune.active,
        character_item: rune.character_item,
        notes: rune.notes,
      },
    })
    changed_runes.push(rune_changed_parm)
    //=========================================================================================================================
    // B. where rune NOT in change array + IS in original array (deleting or updating existing character rune)
    //-----------------------------------------------------------------------------------------------------------
  } else if (changed_idx == -1 && original_idx !== -1) {
    console.log('B. RUNE NOT IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + rune.name)
    //--------------------------------
    // where deleting character rune
    //--------------------------------
    if (del) {
      console.log('B1. CREATE DELETION ENTRY')
      //--------------------
      // add deletion entry
      //--------------------
      rune_changed_parm = createChangedRuneEntry({
        name: rune.name,
        action: 'DELETE',
        id: rune.id, // character_rune id or temp id
      })
      //------------------
      // add update entry
      //------------------
    } else {
      console.log('B2. CREATE UPDATE ENTRY')
      rune_changed_parm = {
        name: rune.name,
        action: 'UPDATE',
        id: rune.id, // character_rune id or temp id
        payload: {
          [change.key]: change.value,
        },
      }
    }
    changed_runes.push(rune_changed_parm)
    //=========================================================================================================================
    // C. where rune IS in change array + IS in original array (updating existing change entry/remove if reverted)
    //--------------------------------------------------------------------------------------------------------------
  } else if (changed_idx !== -1 && original_idx !== -1) {
    console.log('C. RUNE IS IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + rune.name)
    console.log('C1. CHECK IF RUNE CHANGED')
    //--------------------------------
    // where deleting character rune
    //--------------------------------
    if (del) {
      console.log('C2. CREATE DELETION ENTRY')
      //---------------------------------
      // remove change entry where found
      //---------------------------------
      changed_runes.splice(changed_idx, 1)
      //--------------------
      // add deletion entry
      //--------------------
      rune_changed_parm = createChangedRuneEntry({
        name: rune.name,
        action: 'DELETE',
        id: rune.id, // character_rune id or temp id
      })
      changed_runes.push(rune_changed_parm)
      //--------------
      // not deleting
      //--------------
    } else {
      //-----------------------------------------------------------------
      // check if values changed (could have reverted back to originals)
      //-----------------------------------------------------------------
      let rune_changed = isRuneChanged(original_runes[original_idx], rune)
      //---------------
      // value changed
      //---------------
      if (rune_changed) {
        console.log('C3. RUNE VAL CHANGED - UPDATE ENTRY: ' + rune.name)
        //--------------------
        // update rune entry
        //--------------------
        changed_runes[changed_idx].payload[change.key] = change.value
        //---------------------------------------
        // value is original - remove from array
        //---------------------------------------
      } else {
        console.log('C4. RUNE NOT CHANGED - REMOVE ENTRY: ' + rune.name)
        changed_runes.splice(changed_idx, 1)
      }
    }
    //=========================================================================================================================
    // D. where rune IS in change array + NOT in original array (updating and add entry - further changes before commit
    //------------------------------------------------------------------------------------------------------------------
  } else {
    console.log('D. RUNE IS IN CHANGED ARRAY + NOT IN ORIGINAL ARRAY: ' + rune.name)
    //--------------------------------
    // where local rune being deleted
    //--------------------------------
    if (del) {
      console.log('D1. NEW RUNE BEING DELETED - REMOVE ENTRY: ' + rune.name)
      changed_runes.splice(changed_idx, 1)
    } else {
      console.log('D2. UPDATE THE UPDATE ENTRY')
      //-------------------
      // update rune entry
      //-------------------
      console.log('D3. changed_runes[changed_idx] = ', window.$deepCopy(changed_runes[changed_idx]))
      console.log('D4. change = ', change)
      changed_runes[changed_idx].payload[change.key] = change.value
    }
  }
  // console.log('##################### UPDATED changed_runes = ', window.$deepCopy(changed_runes))
  console.log('===================================================')
  return changed_runes
}
